import type { ChipProps } from "@mui/material"
import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export type MarketingOpStatusesName = keyof typeof marketingOpStatusesEnum
const marketingOpStatusesEnum = {
  ACTIVE: { label: "Active", color: "success.main" },
  AWAITING_PUBLICATION: { label: "Attente publication", color: "common.orange" },
  FINISHED: { label: "Terminé", color: "primary.dark" },
  INACTIVE: { label: "Désactivé", color: "common.red" },
} as const satisfies ReferentialEnum<{
  color: string
}>
export const marketingOpStatusesReferential = referentialEnumToReferentialCodeList(
  marketingOpStatusesEnum,
)

export type MarketingOpTypesName = keyof typeof marketingOpTypesEnum
export const marketingOpTypesEnum = {
  DISPLAY_BASIN: {
    label: "Autre opération",
    shortLabel: "Autre opé",
    color: "success",
  },
  PROMOTIONAL: {
    label: "Offre du moment",
    shortLabel: "Offre du moment",
    color: "success",
  },
  BUSINESS: {
    label: "Opération métier",
    shortLabel: "Opé métier",
    color: "primary",
  },
} as const satisfies ReferentialEnum<{
  shortLabel: string
  color: ChipProps["color"]
}>
export const marketingOpTypesReferential =
  referentialEnumToReferentialCodeList(marketingOpTypesEnum)

export type LabMarketingOpStatusesName = keyof typeof labMarketingOpStatusesEnum
const labMarketingOpStatusesEnum = {
  IN_PROGRESS: { label: "En cours", color: "success.main" },
  UPCOMING: { label: "À venir", color: "common.orange" },
  FINISHED: { label: "Clôturé", color: "primary.dark" },
} as const satisfies ReferentialEnum<{
  color: string
}>
export const labMarketingOpStatusesReferential =
  referentialEnumToReferentialCodeList(labMarketingOpStatusesEnum)
